import { Box, Typography, LinearProgress, Card, CardContent } from '@mui/material';

interface ConnectionPoolGaugeProps {
  activeConnections: number;
  poolSize: number;
  utilization: number; // Percentage
}

export default function ConnectionPoolGauge({ activeConnections, poolSize, utilization }: ConnectionPoolGaugeProps) {
  const getColor = () => {
    if (utilization < 70) return 'success';
    if (utilization < 90) return 'warning';
    return 'error';
  };

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h6">Connection Pool</Typography>
          <Typography variant="h6" fontWeight={600}>
            {activeConnections} / {poolSize}
          </Typography>
        </Box>

        <LinearProgress variant="determinate" value={utilization} color={getColor()} sx={{ height: 12, borderRadius: 6, mb: 1 }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="caption" color="text.secondary">
            {utilization.toFixed(1)}% utilization
          </Typography>
          <Typography variant="caption" color={getColor()}>
            {utilization < 70 ? 'Healthy' : utilization < 90 ? 'Warning' : 'Critical'}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
